// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#04C900'
        },
        secondary: {
            main: '#2196f3' // Your secondary color
        },
        gray: {
            main: 'rgba(60, 60, 67, 0.6)'
        }
    },
    typography: {
        fontFamily: 'InstrumentSans',
        fontWeightRegular: 600
    },
    breakpoints: {
        values: {
            mobile: 767,
            tablet: 1200
        }
    }
});

export default theme;
